export const TRANSLATION_KEYS = {
  BUTTON_OVERVIEW_LABEL: "SMART_MATCHING.BUTTON.OVERVIEW_LABEL",
};

export const DEFAULT_TRANSLATIONS = {
  buttonOverviewLabel: "스마트 매칭 시작하기",
};

export const getTranslationKeysArray = () => Object.values(TRANSLATION_KEYS); 